import $ from 'jquery';
import brandContainerInit from '@99designs/brand-container';

import 'app/modules/datetime';
import 'app/lib/transition-end';
import '@99designs/asimov-core';
import '@99designs/asimov-media-query-label';
import '@99designs/asimov-modal';
import '@99designs/asimov-tooltip';

// Initialise asimov-media-query-label outside dom ready check below. It has its own check and we want
// this to fire early on.
$(document).mediaQueryLabel();

$(function() {
    // activate relative date stamps
    $('span.gmttime').dateTime();

    $(document).on('uiNeedsTimeUpdate', function(e, data) {
        $('span.gmttime').dateTime();
    });

    brandContainerInit();

    // activate asimov modals
    $('[data-modal-name]').modal();

    // activate asimov tooltips
    $('[data-tooltip]').tooltip();

    // automatically add CSRF tokens to ajax calls
    var token = $('meta[name="csrf-token"]').attr('content');

    $(document).ajaxSend(function(elm, xhr, s) {
        if (token && (s.type === 'POST' || s.type === 'DELETE' || s.type === 'PUT')) {
            xhr.setRequestHeader(
                'X-Csrf-Token',
                token
            );
        }
    });
});



// WEBPACK FOOTER //
// ./src/web/js/app/layout.js